import mutations from './patientTrafficByTreatment.mutations'
import actions from './patientTrafficByTreatment.actions'
import getters from './patientTrafficByTreatment.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
